import React, { useState } from "react";
import { Flag, Package, Building2 } from "lucide-react";
import PlatformLayout from "@/components/PlatformLayout";
import FeatureCatalogTab from "./features/FeatureCatalogTab";
import PackageMappingTab from "./features/PackageMappingTab";
import TenantOverrideTab from "./features/TenantOverrideTab";

const TABS = [
  { id: "catalog", label: "Feature Catalog", icon: Flag },
  { id: "package", label: "Package Mapping", icon: Package },
  { id: "override", label: "Tenant Override", icon: Building2 },
];

export default function PlatformFeatures() {
  const [tab, setTab] = useState("catalog");

  return (
    <PlatformLayout title="Feature Flags">
      <div data-testid="platform-features-page">
        {/* Tab bar */}
        <div className="flex items-center gap-1 mb-6 border-b border-white/10">
          {TABS.map((t) => {
            const Icon = t.icon;
            const active = tab === t.id;
            return (
              <button key={t.id} onClick={() => setTab(t.id)}
                className={`px-4 py-2.5 text-xs font-black uppercase tracking-wider flex items-center gap-2 border-b-2 transition-colors ${
                  active ? "border-white text-white" : "border-transparent text-white/40 hover:text-white/70"
                }`}
                data-testid={`tab-${t.id}`}>
                <Icon size={13} /> {t.label}
              </button>
            );
          })}
        </div>

        {tab === "catalog" && <FeatureCatalogTab />}
        {tab === "package" && <PackageMappingTab />}
        {tab === "override" && <TenantOverrideTab />}
      </div>
    </PlatformLayout>
  );
}
